import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'kk',
    fullName: 'Kazakh',
    nativeName: 'Қазақ тілі',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Ғажайып нәрсе келе жатыр",
    landing_subtitle: "ArgVoid - қолданбалар мен ойын әзірлеу студиясы. Жақында жаңа нәрселер шығады!",
    select_language: "Тіл таңдаңыз",
    search_placeholder: "Тілдерді іздеу...",
    terms_title: "Қызмет көрсету шарттары",
    policy_title: "Құпиялылық саясаты",
    cookies_title: "Cookie саясаты",
    terms_content: `
        <strong>1. </strong><br> шарттарын қабылдау
        ArgVoid қолданбасына кіру арқылы осы Қызмет көрсету шарттары қабылданады. Бұл шарттар келісілмеген болса, қызметті пайдаланбау керек.<br><br>

        <strong>2. Платформаны пайдалану</strong><br>
        ArgVoid және оның қолданбалары ақпараттық және шығармашылық мақсаттар үшін "сол қалпында" берілген. Қызмет тек заңды мақсаттарда пайдаланылуы керек.<br><br>

        <strong>3. Тыйым салынған әрекет</strong><br>
        Сайттың осалдықтарын пайдалануға, спам жіберуге немесе инфрақұрылымға рұқсатсыз кіруге әрекет жасауға қатаң тыйым салынады.<br><br>

        <strong>4. Жауапкершіліктен бас тарту </strong><br>
        Платформа мен қызметтер кез келген уақытта ескертусіз өзгертілуі мүмкін. Қызметтің жұмыс уақыты немесе қолжетімділігіне қатысты ешқандай кепілдік берілмейді.
    `,
    policy_content: `
        <strong>1. Ақпарат жинағы</strong><br>
        Платформа қазіргі уақытта пайдаланушының аутентификациясын немесе тіркелгі жасауды қажет етпейді. Келушілерден жеке сәйкестендіру ақпараты (мысалы, аттар немесе электрондық пошта мекенжайлары) белсенді түрде жиналмайды.<br><br>

        <strong>2. Data</strong><br> пайдалану
        Сайт трафигін түсіну және қолданбаларды жақсарту үшін негізгі, анонимді талдаулар жиналуы мүмкін. Бұл деректер жеке пайдаланушы идентификацияларына байланысты емес.<br><br>

        <strong>3. Үшінші тарап қызметтері</strong><br>
        Үшінші тарап провайдерлері хостинг және аналитикалық қызметтер үшін пайдаланылуы мүмкін. Осы тиісті провайдерлердің құпиялылық тәжірибелері олардың инфрақұрылымында өңделген анонимді деректерді басқарады.<br><br>

        <strong>4. Деректер қауіпсіздігі</strong><br>
        Платформаны қорғау үшін ақылға қонымды қауіпсіздік шаралары жүзеге асырылады. Дегенмен, Интернет арқылы тасымалдаудың ешбір әдісі толығымен қауіпсіз емес.<br><br>
    `,
    cookies_content: `
        <strong>1. Cookie файлдары және жергілікті сақтау дегеніміз не? </strong><br>
        Cookie файлдары мен шолғыштың жергілікті жады - кіру кезінде конфигурациялау теңшелімдерін есте сақтау үшін құрылғыда сақталған шағын деректер файлдары.<br><br>

        <strong>2. Қолдану мақсаты</strong><br>
        LocalStorage шолғышы конфигурация параметрлерін сақтау үшін қатаң пайдаланылады, мысалы: <br>
        - Тіл таңдаулары<br>
        - Пайдаланушы интерфейсінің конфигурациясы (мысалы, орналасу немесе тақырып параметрлері) <br>
        - уақытша қолданба кэші<br><br>

        <strong>3. Бақылау жоқ</strong><br>
        Cookie файлдары мен жергілікті жад жарнама немесе үшінші тарап бақылау мақсаттары үшін пайдаланылмайды. Барлық сақталған деректер платформаның негізгі функцияларына арналған.<br><br>

        <strong>4. Control</strong><br>
        Браузер деректерін кез келген уақытта браузер параметрлері арқылы тазалауға болады, ол кез келген жергілікті конфигурацияларды қалпына келтіреді.
    `,
    cookie_consent_text: "Біз веб-сайт функцияларының дұрыстығын қамтамасыз ету үшін негізгі cookie файлдарын пайдаланамыз, мысалы, сеансты белсенді ұстау, тіл таңдауыңызды сақтау және басқа теңшелетін конфигурациялар.",
    read_policy: "Cookie саясатын оқыңыз",
    support_title: "Қолдау қызметіне хабарласыңыз",
    support_subject_label: "Тақырып",
    support_message_label: "Хабарлама",
    support_submit_button: "Хабар жіберу",
    support_hint: "Ескертпе: Бұл хабарлама жіберу үшін әдепкі электрондық пошта қолданбаңызды ашады.",
    support_success_msg: "Электрондық пошта қолданбасы ашылуда...",
    support_error_msg: "Хабарды жіберу мүмкін болмады. Тағы жасауды сәл кейінірек көріңізді өтінеміз.",
    explorer_title: "Explorer",
    history_title: "Тарих",
    animation_title: "Анимация",
    config_title: "Конфигурация",
    tool_mouse: "Таңдау (Ctrl+M)",
    tool_brush: "Қылқалам (Ctrl+B)",
    tool_brush_mode: "Ауыстыру режимі (қатты/таза)",
    tool_eraser: "Өшіргіш (Ctrl+E)",
    tool_brush_size: "Қылқалам өлшемін реттеңіз",
    tool_bucket: "Толтыру (Ctrl+F)",
    tool_eyedropper: "Көз тамшысы",
    tool_grid: "Тор (Ctrl+Shift+B)",
    tool_rotate: "Бұру (Ctrl+Shift+R)",
    tool_flip_h: "H бұру (Ctrl+Shift+H)",
    tool_flip_v: "V Flip (Ctrl+Shift+V)",
    tool_transpose: "Транспозиция (Ctrl+Shift+T)",
    label_width: "Ені",
    label_height: "Биіктігі",
    label_frames: "Фреймдер саны",
    label_animation: "Анимация стилі",
    label_background_color: "Фон түсі",
    label_interval: "Интервал",
    tool_anim_config: "Анимация конфигурациясы",
    label_new_width: "Жаңа ені",
    label_new_height: "Жаңа биіктік",
    label_apply: "Қолдану",
    label_colors: "Түстер",
    label_size: "Өлшем",
    label_tolerance: "Толеранттылық",
    val_horizontal: "Көлденең",
    val_vertical: "Тік",
    val_sequence: "Тізбек",
    val_bounce: "Секіру",
    val_random: "Кездейсоқ",
    val_solid: "Қатты",
    val_clear: "Таза",
    action_add_sheet: "Жаңа парақ",
    action_import: "Импорттау",
    action_export: "Экспорттау",
    action_sort_projects: "Сұрыптау",
    sort_date_old: "Ең ескі Бірінші",
    sort_date_new: "Ең жаңасы Бірінші",
    sort_name_az: "Аты (A-Z)",
    sort_name_za: "Аты (Z-A)",
    action_new_sprite: "Жаңа Sprite",
    action_new_project: "Жаңа жоба",
    modal_save_all_title: "Барлық өзгертулерді сақтау",
    modal_save_all_desc: "Сақтау үшін активтерді таңдаңыз:",
    modal_save_selected: "Таңдалғанды ​​сақтау",
    action_saved: "Сақталды",
    modal_create_sprite_title: "Жаңа Sprite жасаңыз",
    modal_create_project_title: "Жаңа жоба жасау",
    modal_add_sheet_title: "Жаңа парақ қосу",
    modal_rename_sheet_title: "Парақтың атын өзгерту",
    modal_rename_sprite_title: "Sprite атын өзгерту",
    modal_delete_sprite_title: "Sprite қолданбасын жою",
    modal_delete_project_title: "Жобаны жою",
    modal_delete_sheet_title: "Парақты жою",
    placeholder_sprite_name: "Аты",
    placeholder_project_name: "Аты",
    placeholder_sheet_name: "Аты",
    placeholder_new_name: "Жаңа атау",
    action_create: "Жасау",
    action_add: "қосу",
    action_rename: "Атын өзгерту",
    action_duplicate: "Көшірме",
    action_delete: "Жою",
    action_cancel: "Болдырмау",
    confirm_delete_sprite: "Осы спрайтты шынымен жойғыңыз келе ме?",
    confirm_delete_project: "Бұл жобаны шынымен жойғыңыз келе ме? Барлық спрайттар жойылады.",
    confirm_delete_sheet: "Осы парақты шынымен жойғыңыз келе ме?",
    err_select_sprite: "Алдымен спрайтты таңдаңыз.",
    err_select_project: "Алдымен жобаны таңдаңыз.",
    err_name_empty: "Аты бос болмауы керек.",
    err_sprite_exists: "Мұндай аты бар спрайт бұрыннан бар.",
    err_project_exists: "Мұндай атау бар жоба бұрыннан бар.",
    err_no_content: "Сақталатын мазмұн жоқ.",
    err_no_changes: "Сақталатын өзгерістер жоқ.",
    err_delete_last_sheet: "Соңғы парақты жою мүмкін емес.",
    err_extract_frames: "Ешбір жақтауды шығару мүмкін болмады.",
    err_indexeddb: "Жергілікті сақтау мүмкін болмады. Браузеріңіз IndexedDB қолдамауы мүмкін.",
    msg_upload_success: "Жүктеп салу сәтті аяқталды: {0}",
    msg_upload_failed: "Жүктеп салу сәтсіз аяқталды: {0}",
    msg_save_success: "Сәтті сақтаңыз.",
    msg_saving: "Сақталуда...",
    msg_multi_save_result: "{0} актив сақталды. {1} сәтсіздік.",
    menu_title: "Мәзір",
    menu_save: "Сақтау",
    menu_save_all: "Барлығын сақтау",
    menu_support: "Қолдау қызметіне хабарласыңыз",
    label_local_storage: "Жергілікті сақтау",
    label_sign_in: "Кіру",
    modal_export_title: "Sprite экспорттау",
    label_filename: "Файл атауы",
    label_format: "Формат",
    action_export_confirm: "Экспорттау",
};

export default translations;
